import { RequestService } from '../../../../../common/services/RequestService';
import { API_AUTHORIZATION_GETPROFILES } from '../../constants';
import { adjustUserProfiles } from '../ProfileList/adjustUserProfiles';

export const getUserProfilesRequest = async userId => {
  const response = await RequestService.get(
    API_AUTHORIZATION_GETPROFILES + '/' + userId
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data
      .filter(p => p.roleId.roleId !== 1 && p.roleId.roleId !== 6)
      .map(profile => adjustUserProfiles(profile))
  );
};
